import { memo } from 'react';
import cn from 'classnames';
import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import { Element, List, RouterLink } from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { Team } from '@zmedia/bm-soccer-ui/modules/match/components';
import styles from './style.module.scss';

const getStatus = (home: number, away: number) => {
    let status = '';
    if (home > away) {
        status = 'win';
    }
    if (home < away) {
        status = 'lose';
    }
    return status;
};

export function TeamFormList(props: any) {
    const { items = [], teamId } = props;

    const renderList = () => {
        return (
            <>
                {items.map((match: IMatch, index: number) => {
                    const isHomeInMatch = match.home.team.id === teamId;
                    const homeScore = match.home.score;
                    const awayScore = match.away.score;

                    let status = '';
                    if (isHomeInMatch) {
                        status = getStatus(homeScore, awayScore);
                    } else {
                        status = getStatus(awayScore, homeScore);
                    }

                    return (
                        <List.Item key={index}>
                            <RouterLink
                                to={`${URL_SOCCER_PAGE.SUBPATH}${match.path}`}
                                title={
                                    match.home.team.name +
                                    ' đấu với ' +
                                    match.away.team.name
                                }
                            >
                                <Team team={match.home.team} />
                                <Element
                                    className={cn(styles['score'], {
                                        [styles[`is-${status}`]]: status,
                                    })}
                                >
                                    {match.home.score} - {match.away.score}
                                </Element>
                                <Team team={match.away.team} />
                            </RouterLink>
                        </List.Item>
                    );
                })}
            </>
        );
    };

    return <List className={styles['form-team-list']}>{renderList()}</List>;
}

export default memo(TeamFormList);
